import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from './SoundAssetKeys';

/** @type {Phaser.Sound.WebAudioSound} */
let gameJingle = null;

export function createJingle(scene) {
  gameJingle = ABCyaPhaser.Audio.createSound(scene);
}

export function playGameJingle() {
  if (gameJingle.isPlaying) return;

  ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle, gameJingle, 1, true, 0);
}

export function stopGameJingle() {
  gameJingle.stop();
}

export function toggleMute(mute) {
  gameJingle.mute = mute;
}

export function isMuted() {
  return gameJingle.mute;
}